/**
 * Returns the first argument it receives.
 */
export default function identityFunc(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/jsutils/identityFunc.mjs
// module id = 217
// module chunks = 17